"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[7865],{

/***/ 76411:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ strapi_getRichTextStateFromMessage)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(57890);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(58738);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__(73074);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
;// CONCATENATED MODULE: ./src/modules/strapi/isRichTextStateEmpty.ts


var getRichTextStateFromMessage = function(richTextState) {
    var _richTextState_root_children, _richTextState_root, _richTextState_root_children1, _richTextState_root1;
    return (richTextState === null || richTextState === void 0 ? void 0 : (_richTextState_root = richTextState.root) === null || _richTextState_root === void 0 ? void 0 : (_richTextState_root_children = _richTextState_root.children) === null || _richTextState_root_children === void 0 ? void 0 : _richTextState_root_children.length) === 0 || (richTextState === null || richTextState === void 0 ? void 0 : (_richTextState_root1 = richTextState.root) === null || _richTextState_root1 === void 0 ? void 0 : (_richTextState_root_children1 = _richTextState_root1.children) === null || _richTextState_root_children1 === void 0 ? void 0 : _richTextState_root_children1.some(function(node) {
        var _node_children;
        return (node === null || node === void 0 ? void 0 : (_node_children = node.children) === null || _node_children === void 0 ? void 0 : _node_children.length) !== 0;
    })) === false;
};
/* harmony default export */ const isRichTextStateEmpty = (getRichTextStateFromMessage);

;// CONCATENATED MODULE: ./src/modules/strapi/getRichTextStateFromMessage.ts



var getRichTextStateFromMessage_getRichTextStateFromMessage = function(state) {
    if (!state) {
        return null;
    }
    try {
        var editorState = JSON.parse(state);
        var isEditorStateEmpty = isRichTextStateEmpty(editorState);
        return !isEditorStateEmpty ? editorState : null;
    } catch (error) {
        logger/* default */.Z.error(error);
        return null;
    }
};
/* harmony default export */ const strapi_getRichTextStateFromMessage = (getRichTextStateFromMessage_getRichTextStateFromMessage);


/***/ }),

/***/ 86593:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47361);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}

var DEFAULT_INDENT = {
    mobile: "mt-40",
    desktop: "mt-40"
};
var INDENT_MAP = {
    top_0: "mt-0",
    top_4: "mt-4",
    top_6: "mt-6",
    top_8: "mt-8",
    top_12: "mt-12",
    top_16: "mt-16",
    top_20: "mt-20",
    top_24: "mt-24",
    top_32: "mt-32",
    top_36: "mt-36",
    top_40: "mt-40",
    top_48: "mt-48",
    top_56: "mt-56",
    top_60: "mt-60",
    top_64: "mt-64",
    top_72: "mt-72",
    top_80: "mt-80",
    top_96: "mt-96"
};
var useStrapiBlockIndent = function(indent, defaultIndent) {
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().isMobile;
    var blockIndent = isMobile ? indent === null || indent === void 0 ? void 0 : indent.mobile : indent === null || indent === void 0 ? void 0 : indent.desktop;
    if (!INDENT_MAP[blockIndent]) {
        var defaultBlockIndent = _object_spread({}, DEFAULT_INDENT, defaultIndent);
        return isMobile ? defaultBlockIndent.mobile : defaultBlockIndent.desktop;
    }
    return INDENT_MAP[blockIndent];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useStrapiBlockIndent);


/***/ })

}]);